import { useCallback, useEffect, useState } from 'react'
import * as XLSX from 'xlsx'
import NavBar from '../../structure/NavBar'
import { NavBarTop } from '../../structure/NavBarTop'
import { useDispatch, useSelector } from 'react-redux'
import { v4 as uuidv4 } from 'uuid'
import {
  updateTopHeader,
  updateLoading
} from '../../../redux/features/common/commonSlice'
import { Button, Dropdown, Form, InputGroup } from 'react-bootstrap'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import Swal from 'sweetalert2'
import Utils from '../../constants/Utils'
import urls from '../../constants/apiurl'
import { showDangerToast, showToast } from '../../constants/toaster'
import ApiCaller from '../../constants/ApiCaller'
import AddIcon from '@mui/icons-material/Add'
import SearchIcon from '@mui/icons-material/Search'
import { Box, Switch, Collapse } from '@mui/material'
import NoDataImg from '../../../assets/img/no-data.gif'
import Pagination from '@mui/material/Pagination'
import InsufficientPermission from '../../custom/InSufficientPermission'
import { AddTaxTemplate } from './Add'
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { IconButton, Menu, MenuItem } from "@mui/material";

const label = { inputProps: { 'aria-label': 'Size switch demo' } }

// Inline styles for better visual hierarchy
const styles = {
  parentRow: {
    backgroundColor: '#f8f9fa',
    fontWeight: '500',
    borderLeft: '4px solid #007bff'
  },
  childRow: {
    backgroundColor: '#ffffff',
    borderLeft: '3px solid #28a745',
    fontSize: '0.9rem'
  },
  expandButton: {
    marginRight: '8px',
    color: '#007bff',
    padding: '2px'
  },
  childIndicator: {
    marginRight: '8px',
    color: '#6c757d',
    fontWeight: 'bold'
  },
  badge: {
    fontSize: '0.75rem',
    padding: '0.25rem 0.5rem'
  },
  table: {
    fontSize: '0.875rem'
  }
};

export const TaxTemplatesList = props => {
  const { formatDate } = Utils();
  const [countryDropdownText, setCountryDropdownText] = useState({
    id: '',
    lable: 'Select Country'
  })
  const [countryCodeList, setCountryCodeList] = useState([
    {
      id: '',
      name: 'Select Country'
    }
  ])
  const dispatch = useDispatch()
  const userData = useSelector(state => state?.userData)
  const [taxTemplateFormData, setTaxTemplateFormData] = useState({
    id: '',
    name: '',
    taxRate: '',
    adminCreated: true,
    selfMerchantTax: false,
    percentageOnTaxType: false,
    percentageOnTypeId: '',
    fixed: false,
    merchantId: '',
    countryId: ''
  })
  const [showAddState, setShowAddState] = useState(false)
  const [showAddImportDistrict, setShowAddImportDistrict] = useState(false)
  const [selectedStateId, setSelectedStateId] = useState('')
  const [sheetIndex, setSheetIndex] = useState('')
  const [searchText, setSearchText] = useState('')
  const [statusDropdownText, setStatusDropdownText] = useState('Select Status')
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [pagerecord, setPagerecord] = useState({
    totalItems: 0,
    pageNumber: 1,
    pageSize: 10,
    totalPages: 1
  })
  const [callAPi, setCallAPi] = useState('')
  const [sort_type, setSortType] = useState('createdAt')
  const [sort_order, setSortOrder] = useState(false)
  const [datalist, setDatalist] = useState([])
  const [edit, setEdit] = useState(false)
  const [active, setActive] = useState(false)
  const [deletePermission, setDeletePermission] = useState(false)
  const LOADING_ENABLE = useSelector(state => state?.loading)
  const [page, setPage] = useState(1)
  const [data, setData] = useState([])
  const handleChange = (event, value) => {
    setPage(value)
    setPagerecord({
      totalItems: pagerecord?.totalItems,
      totalPages: pagerecord?.totalPages,
      pageNumber: value,
      pageSize: 10
    })
    setCallAPi(uuidv4())
  }
  const [rolePermissionData, setRolePermissionData] = useState({})
  const [subAdminListByRole, setsubAdminListByRole] = useState({})
  const [viewPermissionControl, setViewPermissionControl] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [expandedRows, setExpandedRows] = useState(new Set());
  const open = Boolean(anchorEl);

  useEffect(() => {
    dispatch(updateTopHeader('Tax Templates Manager'))
  }, [])

  useEffect(() => {
    if (viewPermission) {
      getTaxTemplatesList()
      getCountryCodeList()
    }
  }, [callAPi])

  const handleAddState = () => {
    setTaxTemplateFormData({
      id: '',
      name: '',
      taxRate: '',
      adminCreated: true,
      selfMerchantTax: false,
      percentageOnTaxType: false,
      percentageOnTypeId: '',
      fixed: false,
      merchantId: '',
      countryId: ''
    })
    setShowAddState(true)
  }

  const handleExpandRow = (rowId) => {
    const newExpandedRows = new Set(expandedRows);
    if (newExpandedRows.has(rowId)) {
      newExpandedRows.delete(rowId);
    } else {
      newExpandedRows.add(rowId);
    }
    setExpandedRows(newExpandedRows);
  };

  const handleExpandAll = () => {
    const rowsWithSubTax = datalist.filter(item => item.subTaxList && item.subTaxList.length > 0);
    if (expandedRows.size === rowsWithSubTax.length) {
      // All are expanded, collapse all
      setExpandedRows(new Set());
    } else {
      // Expand all
      setExpandedRows(new Set(rowsWithSubTax.map(item => item.id)));
    }
  };

  const handleFilterClick = useCallback(() => {
    setPage(1)
    setPagerecord({
      ...pagerecord,
      pageNumber: 1
    })
    setCallAPi(uuidv4())
  }, [searchText, startDate, endDate, statusDropdownText, countryDropdownText])

  const handleResetFilter = () => {
    setStartDate(null)
    setEndDate(null)
    setStatusDropdownText('Select Status')
    setSearchText('')
    setCountryDropdownText({
      id: '',
      lable: 'Select Country'
    })
    setPage(1)
    setPagerecord({
      ...pagerecord,
      pageNumber: 1
    })
    setCallAPi(uuidv4())
  }

  const handleFileChange = e => {
    const file = e.target.files[0]
    const reader = new FileReader()

    reader.onload = event => {
      const binaryStr = event.target.result
      const workbook = XLSX.read(binaryStr, { type: 'binary' })

      // Assuming you want to read the first sheet
      const sheetName = workbook.SheetNames[0]
      const worksheet = workbook.Sheets[sheetName]

      // Convert to JSON
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 })
      let allCountry = []
      jsonData?.map(data => {
        let singleCountry = {
          parentId: 'bbca05da-c63d-461d-8a78-06c57d9cfbda',
          name: data[0]
        }
        allCountry.push(singleCountry)
      })
      setData(allCountry)
    }

    reader.readAsBinaryString(file)
  }

  const handleImportState = async () => {
    try {
      dispatch(updateLoading(true))
      let postJson = {
        dataList: data
      }
      let path = urls.importState
      let res = await ApiCaller.post(postJson, path, userData?.access_token)
      const response = await res.response.json()
      if (response.status == 200) {
        dispatch(updateLoading(false))
        showToast(response?.message)
        getTaxTemplatesList()
      } else {
        dispatch(updateLoading(false))
        showDangerToast(response.message)
      }
    } catch (error) {
      dispatch(updateLoading(false))
      console.error(error)
      showDangerToast(error.message)
    }
  }


  const getGetRolePermssions = async id => {
    try {
      dispatch(updateLoading(true))
      let path = urls.fetchPermission + '/' + id
      let res = await ApiCaller.get({}, path, userData?.access_token)
      const response = await res.response.json()
      if (response.status == 200) {
        dispatch(updateLoading(false))
        setRolePermissionData(response?.data)
        setViewPermissionControl(true)
      } else {
        dispatch(updateLoading(false))
        showDangerToast(response.message)
      }
    } catch (error) {
      dispatch(updateLoading(false))
      console.error(error)
      showDangerToast(error.message)
    }
  }

  const getCountryCodeList = async () => {
    try {
      dispatch(updateLoading(true))
      let path = urls.countryCodeList
      let res = await ApiCaller.get({}, path, userData?.access_token)
      const response = await res.response.json()
      if (response.status == 200) {
        dispatch(updateLoading(false))
        let tempArray = []
        tempArray.push(...response?.data)
        setCountryCodeList(tempArray)
      } else {
        dispatch(updateLoading(false))
        showDangerToast(response.message)
      }
    } catch (error) {
      dispatch(updateLoading(false))
      console.error(error)
      showDangerToast(error.message)
    }
  }

  const handleStatusChange = async (event, id) => {
    try {
      dispatch(updateLoading(true))
      let path = urls.changeStateStatus + '/' + id
      let res = await ApiCaller.put({}, path, userData?.access_token)
      const response = await res.response.json()
      if (response.status == 200) {
        dispatch(updateLoading(false))
        showToast(response?.message)
        getTaxTemplatesList()
      } else {
        dispatch(updateLoading(false))
        showDangerToast(response.message)
      }
    } catch (error) {
      dispatch(updateLoading(false))
      console.error(error)
      showDangerToast(error.message)
    }
  }

  const handleOnSubmitTaxTemplateModel = async () => {
    try {
      dispatch(updateLoading(true))
      
      // Prepare the request data according to backend API structure
      const requestData = {
        id: taxTemplateFormData.id || undefined,
        name: taxTemplateFormData.name,
        taxRate: parseFloat(taxTemplateFormData.taxRate),
        adminCreated: true,
        selfMerchantTax: false,
        percentageOnTaxType: taxTemplateFormData.percentageOnTaxType || false,
        percentageOnTypeId: taxTemplateFormData.percentageOnTypeId || '',
        fixed: taxTemplateFormData.fixed || false,
        merchantId: '',
        countryId: taxTemplateFormData.countryId
      }
      
      let path = taxTemplateFormData.id ? urls.updateTaxTemplate : urls.addTaxTemplate
      let res = await ApiCaller.post(
        requestData,
        path,
        userData?.access_token
      )
      const response = await res.response.json()
      if (response.status == 200) {
        dispatch(updateLoading(false))
        showToast(response?.message)
        getTaxTemplatesList()
        setShowAddState(false)
        setTaxTemplateFormData({
          id: '',
          name: '',
          taxRate: '',
          adminCreated: true,
          selfMerchantTax: false,
          percentageOnTaxType: false,
          percentageOnTypeId: '',
          fixed: false,
          merchantId: '',
          countryId: ''
        })
        return true
      } else {
        dispatch(updateLoading(false))
        showDangerToast(response.message)
        return false
      }
    } catch (error) {
      dispatch(updateLoading(false))
      console.error(error)
      showDangerToast(error.message)
      return false
    }
  }

  const getTaxTemplatesList = async () => {
    let startDateObject
    let endDateObject
    if (startDate?.toDate()) {
      let newDate = new Date(startDate?.toDate())
      // newDate.setDate(newDate.getDate() + 1)
      startDateObject = newDate
    }
    if (endDate?.toDate()) {
      let newDate = new Date(endDate?.toDate())
      // newDate.setDate(newDate.getDate() + 1)
      endDateObject = newDate
    }
    try {
      dispatch(updateLoading(true))
      let postJson = {
        searchTxt: searchText?.trim(),
        page: pagerecord?.pageNumber - 1 || 0,
        size: pagerecord.pageSize || 10,
        sortKey: sort_type,
        order: sort_order,
        countryId: countryDropdownText?.id ? countryDropdownText?.id : '',
        active:
          statusDropdownText === 'Active'
            ? true
            : statusDropdownText === 'In Active'
              ? false
              : true,
        startDate: startDateObject !== null ? startDateObject : '',
        endDate: endDateObject !== null ? endDateObject : ''
      }
      let path = urls.taxTemplatesList
      let res = await ApiCaller.get(postJson, path, userData?.access_token)
      const response = await res.response.json()
      if (response.status == 200) {
        dispatch(updateLoading(false))
        setDatalist(response?.data?.items)
        setPagerecord({
          totalItems: response?.data?.totalItems,
          totalPages: response?.data?.totalPages,
          pageNumber: pagerecord?.pageNumber,
          pageSize: 10
        })
      } else {
        dispatch(updateLoading(false))
        showDangerToast(response.message)
      }
    } catch (error) {
      dispatch(updateLoading(false))
      console.error(error)
      showDangerToast(error.message)
    }
  }

  const handleMenuClick = (event, item) => {
    setAnchorEl(event.currentTarget);
    setSelectedTemplate(item);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedTemplate(null);
  };

  const handleEditState = item => {
    handleMenuClose();
    
    // Transform the item data to match the new form structure
    const transformedData = {
      id: item.id || '',
      name: item.name || '',
      taxRate: item.taxRate || '',
      adminCreated: item.adminCreated !== undefined ? item.adminCreated : true,
      selfMerchantTax: item.selfMerchantTax !== undefined ? item.selfMerchantTax : false,
      percentageOnTaxType: item.percentageOnTaxType || false,
      percentageOnTypeId: item.percentageOnTypeId || '',
      fixed: item.fixed || false,
      merchantId: item.merchantId || '',
      countryId: item.countryId || ''
    };
    
    setTaxTemplateFormData(transformedData);
    setShowAddState(true);
  }

  const handleDeleteState = item => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes!'
    }).then(async result => {
      if (result.isConfirmed) {
        deleteApiCall(item?.id)
      }
    })
  }

  const userPermisiions = useSelector(state => state?.permission)
  let currentModulePermission;
  let viewPermission = true;
  let editPermission = true;
  let deletePermissionVal = true;
  let activePermission = true;

  if (userPermisiions?.modules.length > 0) {
    currentModulePermission = userPermisiions.modules.find((element) => {
      if (element.moduleId === '31') {
        return element
      }
    })?.permissions
    viewPermission = currentModulePermission.find((element) => {
      if (element.name === 'VIEW') {
        return element
      }
    }).isEnable
    editPermission = currentModulePermission.find((element) => {
      if (element.name === 'EDIT') {
        return element
      }
    }).isEnable
    deletePermissionVal = currentModulePermission.find((element) => {
      if (element.name === 'DELETE') {
        return element
      }
    }).isEnable
    activePermission = currentModulePermission.find((element) => {
      if (element.name === 'ACTIVE') {
        return element
      }
    }).isEnable
  }

  const deleteApiCall = async id => {
    try {
      dispatch(updateLoading(true))
      let path = urls.deleteState + '/' + id
      let res = await ApiCaller.delete({}, path, userData?.access_token)
      const response = await res.response.json()
      if (response.status == 200) {
        dispatch(updateLoading(false))
        Swal.fire('Deleted!', response?.message, 'success')
        getTaxTemplatesList()
      } else {
        dispatch(updateLoading(false))
        showDangerToast(response.message)
      }
    } catch (error) {
      dispatch(updateLoading(false))
      console.error(error)
      showDangerToast(error.message)
    }
  }

  return (
    <>
      <NavBar />
      <div className='main-content'>
        <NavBarTop />
        <div className='header'>
          <div className='logo'>
            <div className='header bg-gradient-primary pb-8 pt-5 pt-md-8'></div>
          </div>
        </div>
        {
          viewPermission ? (
            <>
              <div className='container-fluid mt--7'>
                <div className='row'>
                  <div className='col text-left'>
                    <div className='card shadow'>
                      <div className='card-header border-0'>
                        <div className='row align-items-center text-left'>
                          <div className='col'>
                            <h3 className='mb-0'>Tax Templates List</h3>
                          </div>
                          <div className='col text-right'>
                            {userData.admin ? (
                              <a
                                onClick={handleAddState}
                                className='btn btn-sm btn-primary text-white'
                              >
                                <AddIcon />
                                Add New
                              </a>
                            ) : editPermission ? (
                              <a
                                onClick={handleAddState}
                                className='btn btn-sm btn-primary text-white'
                              >
                                <AddIcon />
                                Add New
                              </a>
                            ) : (
                              <></>
                            )}
                            
                            {/* Expand/Collapse All Button */}
                            {datalist && datalist.some(item => item.subTaxList && item.subTaxList.length > 0) && (
                              <Button
                                variant="outlined"
                                size="small"
                                onClick={handleExpandAll}
                                className="ml-2"
                                style={{ marginLeft: '8px' }}
                              >
                                {expandedRows.size === datalist.filter(item => item.subTaxList && item.subTaxList.length > 0).length 
                                  ? 'Collapse All' 
                                  : 'Expand All'
                                }
                              </Button>
                            )}

                            {/* <a href='#!' className='btn btn-sm btn-primary'>
                        See all
                      </a> */}
                          </div>
                        </div>
                      </div>
                      
                      {/* Tax Summary Info */}
                      {datalist && datalist.length > 0 && (
                        <div className='card-header border-0 py-2'>
                          <div className='row'>
                            <div className='col'>
                              <small className='text-muted'>
                                <strong>Summary:</strong> {datalist.length} Parent Tax{datalist.length > 1 ? 'es' : ''} | {' '}
                                {datalist.reduce((total, item) => total + (item.subTaxList ? item.subTaxList.length : 0), 0)} Sub Tax{datalist.reduce((total, item) => total + (item.subTaxList ? item.subTaxList.length : 0), 0) > 1 ? 'es' : ''}
                              </small>
                            </div>
                          </div>
                        </div>
                      )}
                      
                      <div className='card-header border-0'>
                        <div className='row align-items-center text-left'>
                          <div className='col-md-3'>
                            <InputGroup
                              className='mb-2'
                              style={{ borderRadius: '10px' }}
                            >
                              <Form.Control
                                placeholder='Search by Tax Name'
                                value={searchText}
                                onChange={e => setSearchText(e.target.value)}
                                aria-label='Amount (to the nearest dollar)'
                              />
                            </InputGroup>
                          </div>
                          <div className='col-md-2'>
                            <Dropdown>
                              <Dropdown.Toggle
                                variant='success'
                                style={{
                                  backgroundColor: 'white',
                                  color: 'black',
                                  border: '1px solid #cad1d7',
                                  boxShadow: 'none',
                                  transform: 'none'
                                }}
                                id='dropdown-basic'
                              >
                                {countryDropdownText?.lable}
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                {countryCodeList?.map((item, i) => {
                                  return (
                                    <>
                                      <Dropdown.Item
                                        eventKey={item?.id}
                                        onClick={() => {
                                          setCountryDropdownText({
                                            id: item?.id,
                                            lable: item?.name
                                          })
                                        }}
                                      >
                                        {item?.name}
                                      </Dropdown.Item>
                                    </>
                                  )
                                })}
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                          <div className='col-md-2'>
                            <Dropdown>
                              <Dropdown.Toggle
                                variant='success'
                                style={{
                                  backgroundColor: 'white',
                                  color: 'black',
                                  border: '1px solid #cad1d7',
                                  boxShadow: 'none',
                                  transform: 'none'
                                }}
                                id='dropdown-basic'
                              >
                                {statusDropdownText}
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                <Dropdown.Item
                                  onClick={() =>
                                    setStatusDropdownText('Select Status')
                                  }
                                >
                                  Select Status
                                </Dropdown.Item>
                                <Dropdown.Item
                                  onClick={() => setStatusDropdownText('Active')}
                                >
                                  Active
                                </Dropdown.Item>
                                <Dropdown.Item
                                  onClick={() => setStatusDropdownText('In Active')}
                                >
                                  In Active
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                          <div className='col-md-6 mb-3'>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DemoContainer
                                components={['DatePicker', 'DatePicker']}
                              >
                                <DatePicker
                                  disableFuture
                                  className='custom-date'
                                  label='From Date'
                                  value={startDate}
                                  onChange={newValue => setStartDate(newValue)}
                                  maxDate={endDate}
                                />
                                <DatePicker
                                  disableFuture
                                  label='To Date'
                                  value={endDate}
                                  onChange={newValue => setEndDate(newValue)}
                                  minDate={startDate}
                                />
                              </DemoContainer>
                            </LocalizationProvider>
                          </div>
                          <div className='col-md-3 mb-2'>
                            <Button
                              variant='contained'
                              className='custom-filter-btn'
                              onClick={handleFilterClick}
                            >
                              Filter
                            </Button>
                            <Button
                              variant='contained'
                              className='ml-2 custom-filter-btn'
                              onClick={handleResetFilter}
                            >
                              Reset
                            </Button>
                            {/* <input type='file' onChange={handleFileChange} /> */}
                            {/* <Button
                        variant='contained'
                        className='ml-2 custom-filter-btn'
                        onClick={handleImportState}
                      >
                        Import Excel
                      </Button> */}
                          </div>
                        </div>
                      </div>
                      <div className='table-responsive'>
                        {datalist && datalist?.length > 0 ? (
                          <>
                            <table className='table align-items-center table-flush' style={styles.table}>
                              <thead className='thead-light'>
                                <tr>
                                  <th scope='col'>S/No.</th>
                                  <th scope='col'>Tax Name</th>
                                  <th scope='col'>Rate (%)</th>
                                  <th scope='col'>Merchant Specific</th>
                                  <th scope='col'>Merchant Name</th>
                                  <th scope='col'>Country Name</th>
                                  <th scope='col'>Created At</th>
                                  <th scope='col'>Status</th>
                                  {
                                    (editPermission || deletePermissionVal) &&
                                    <th scope='col'>Action</th>
                                  }
                                </tr>
                              </thead>
                              <tbody>
                                {datalist &&
                                  datalist?.map((data, i) => {
                                    const startIndex =
                                      (pagerecord.pageNumber - 1) *
                                      pagerecord.pageSize;
                                    const isExpanded = expandedRows.has(data?.id);
                                    const hasSubTax = data?.subTaxList && data?.subTaxList.length > 0;
                                    
                                    return (
                                      <>
                                        <tr key={data?.id} style={styles.parentRow}>
                                          <td>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                              {hasSubTax && (
                                                <IconButton 
                                                  size="small" 
                                                  onClick={() => handleExpandRow(data?.id)}
                                                  style={styles.expandButton}
                                                >
                                                  {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                                </IconButton>
                                              )}
                                              <span>{startIndex + i + 1}</span>
                                            </div>
                                          </td>
                                          <td>
                                            <strong>{data?.name}</strong>
                                            {hasSubTax && (
                                              <small style={{ display: 'block', color: '#6c757d' }}>
                                                ({data?.subTaxList.length} sub tax{data?.subTaxList.length > 1 ? 'es' : ''})
                                              </small>
                                            )}
                                          </td>
                                          <td><strong>{data?.taxRate}%</strong></td>
                                          <td>
                                            <span className={`badge ${data?.merchantSpecificTax ? 'badge-success' : 'badge-secondary'}`}>
                                              {data?.merchantSpecificTax ? 'Yes' : 'No'}
                                            </span>
                                          </td>
                                          <td>{data?.merchantName || '-'}</td>
                                          <td>{data?.countryName}</td>
                                          <td>{formatDate(data?.createdAt)}</td>
                                          <td>
                                            {userData.admin ? (
                                              <Switch
                                                {...label}
                                                checked={data?.active}
                                                onChange={e =>
                                                  handleStatusChange(e, data?.id)
                                                }
                                                size='small'
                                              />
                                            ) : viewPermission ? (
                                              <Switch
                                                {...label}
                                                checked={data?.active}
                                                disabled={!activePermission}
                                                onChange={e =>
                                                  handleStatusChange(e, data?.id)
                                                }
                                                size='small'
                                              />
                                            ) : (
                                              <></>
                                            )}
                                          </td>
                                          {(editPermission || deletePermissionVal) && (
                                            <td className='text-center'>
                                              <IconButton size="small" onClick={e => handleMenuClick(e, data)}>
                                                <MoreVertIcon />
                                              </IconButton>
                                              <Menu
                                                anchorEl={anchorEl}
                                                open={open && selectedTemplate?.id === data?.id}
                                                onClose={handleMenuClose}
                                                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                                                transformOrigin={{ vertical: "top", horizontal: "right" }}
                                              >
                                                {(userData.admin || editPermission) && (
                                                  <MenuItem onClick={() => handleEditState(data)}>
                                                    Edit
                                                  </MenuItem>
                                                )}
                                              </Menu>
                                            </td>
                                          )}
                                        </tr>
                                        
                                        {/* Sub Tax Rows */}
                                        {hasSubTax && isExpanded && data?.subTaxList.map((subTax, subIndex) => (
                                          <tr key={`${data?.id}-sub-${subTax?.id}`} style={styles.childRow}>
                                            <td style={{ paddingLeft: '40px' }}>
                                              <span style={{ color: '#6c757d' }}>
                                                {startIndex + i + 1}.{subIndex + 1}
                                              </span>
                                            </td>
                                            <td style={{ paddingLeft: '20px' }}>
                                              <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <span style={styles.childIndicator}>└─</span>
                                                {subTax?.name}
                                              </div>
                                              {subTax?.adminCreated !== undefined && (
                                                <small style={{ display: 'block', color: '#6c757d' }}>
                                                  Created by: {subTax?.adminCreated ? 'Admin' : 'Merchant'}
                                                </small>
                                              )}
                                            </td>
                                            <td>{subTax?.taxRate}%</td>
                                            <td>{subTax?.fixed ? 'Fixed' : 'Percentage'}</td>
                                            <td>
                                              <span className={`badge ${subTax?.merchantSpecificTax ? 'badge-success' : 'badge-secondary'}`}>
                                                {subTax?.merchantSpecificTax ? 'Yes' : 'No'}
                                              </span>
                                            </td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            {(editPermission || deletePermissionVal) && (
                                              <td className='text-center'>
                                                <IconButton size="small" onClick={e => handleMenuClick(e, subTax)}>
                                                  <MoreVertIcon />
                                                </IconButton>
                                              </td>
                                            )}
                                          </tr>
                                        ))}
                                      </>
                                    )
                                  })}
                              </tbody>
                            </table>
                          </>
                        ) : (
                          <>
                            <div className='text-center'>
                              <img width={'25%'} src={NoDataImg}></img>
                              <br />
                              <label style={{ fontWeight: 'bold' }}>
                                {LOADING_ENABLE ? (
                                  <>Loading Data.....</>
                                ) : (
                                  <>No Data Found</>
                                )}
                              </label>
                            </div>
                          </>
                        )}
                      </div>
                      {datalist && datalist.length > 0 ? (
                        <div className='card-footer py-4'>
                          <Box
                            display='flex'
                            justifyContent='right'
                            alignItems='center'
                          >
                            <span>Total record: {pagerecord?.totalItems}</span>
                            <Pagination
                              className='custom-pagination-class'
                              count={pagerecord?.totalPages}
                              page={page}
                              onChange={handleChange}
                              color='secondary'
                            />
                          </Box>
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <AddTaxTemplate
                show={showAddState}
                countryCodeList={countryCodeList}
                taxTemplateFormData={taxTemplateFormData}
                rolePermissionData={rolePermissionData}
                subAdminListByRole={subAdminListByRole}
                setTaxTemplateFormData={setTaxTemplateFormData}
                onSubmit={() => handleOnSubmitTaxTemplateModel()}
                onHide={() => setShowAddState(false)}
              />
            </>
          ) : (<InsufficientPermission />)
        }
      </div>
    </>
  )
}
